<template>
    <b-modal id="bv-modal-add-status" size="lg" title="Adicionar um novo status" scrollable centered no-stackin>
        <b-container fluid>
            <form id="add-config-email">
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label for="status-name">Nome do Status</label>
                            <input type="text" class="form-control" id="status-name" v-model="form.name" placeholder="nome do status" :readonly="form.immutable">
                        </div>
                    </div>

                    <div class="col">
                        <div class="form-group">
                            <label for="status-color">Cor</label>
                            <input type="color" class="form-control" v-model="form.color" id="status-color">
                        </div>
                    </div>

                    <div class="col">
                        <div class="form-group">
                            <label for="status-color">Finalizador</label>
                            <div class="custom-control custom-switch mb-3">
                                <input v-model="form.is_finisher" type="checkbox"
                                    class="custom-control-input" id="is_finisher" :disabled="form.immutable"/>
                                <label class="custom-control-label" for="is_finisher">
                                    {{ form.is_finisher ? 'SIM' : 'NÃO' }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </b-container>

        <template #modal-footer>
            <div class="d-flex flex-row-reverse justify-content-between" style="width: 100%;">
                <button type="submit" @click.prevent="submitForm" class="btn btn-primary" :disabled="loading">
                    <span v-if="loading">
                        <i class="fas fa-spinner fa-pulse"></i> Aguarde...
                    </span>
                    <span v-else>
                        <i class="fas fa-save"></i> Salvar
                    </span>
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>

export default {
    name: "StatusTicketModal",
    data() {
        return {
            loading: false,
            dataEdit: {},
            form: {
                name: '',
                color: '',
                immutable: false,
                is_finisher: false,
            }
        }
    },
    computed: {
        isEditing() {
            return this.dataEdit && this.dataEdit.id
        },
    },
    watch: {
        dataEdit: {
            handler(newData) {
                if (newData && Object.keys(newData).length > 0) {
                    this.loadFormData(newData)
                }
            },
            immediate: true
        }
    },
    methods: {
        openModal(data) {
            this.resetForm();
            if (data) {
                this.dataEdit = data;
                this.loadFormData(data);
            }
            this.$bvModal.show('bv-modal-add-status');
        },
        closeModal(data = null) {
            this.loading = false;
            this.resetForm();
            if (data) this.$emit("updateStatusTable", data);
            this.$bvModal.hide('bv-modal-add-status');
        },
        loadFormData(data) {
            this.form.id = data.id;
            this.form.name = data.name;
            this.form.color = data.color;
            this.form.immutable = data.immutable;
            this.form.is_finisher = data.is_finisher;
        },
        resetForm() {
            this.form = {
                name: '',
                color: '',
                is_finisher: false,
            }
            this.dataEdit = {};
        },
        validateForm() {
            if (!this.form.name) {
                Swal.fire({
                    type: "error",
                    text: "Campo 'Nome' é obrigatório!"
                });
                return false;
            }

            return true;
        },
        async submitForm() {
            if (!this.validateForm()) return;
            this.loading = true;
            const formData = { ...this.form };
            try {
                if (this.form.id) {
                    Swal.fire({
                        title: 'Deseja alterar esse status?',
                        text: `As alterações realizadas nesse status serão aplicadas apenas para os próximos tickets abertos.
                        Tickets anteriormente abertos com esse status permaneceram inalterados.`,
                        showCancelButton: true,
                        confirmButtonText: 'Sim',
                        cancelButtonText: 'Não',
                        type: "question",
                        showCloseButton: true,
                        reverseButtons: true
                    }).then(async ({value}) => {
                        if (!value) return this.loading = false;
                        const { data } = await axios.put("ticket/status", formData)
                        Swal.fire({
                            type: "success",
                            text: "Status atualizado com sucesso."
                        });
                        this.closeModal(data);
                    });

                    
                } else {
                    const { data } = await axios.post("ticket/status", formData)
                    Swal.fire({
                        type: "success",
                        text: "Status salvo com sucesso."
                    });
                    
                    this.closeModal(data);
                }
            } catch (error) {
                console.error(error);
                Swal.fire({
                    type: "error",
                    text: "Falha ao salvar status! Valide todos os campos e tente novamente."
                });
                this.loading = false;
            }
        },
    },
}
</script>

<style scoped>
.custom-control-label {
    font-weight: 500;
}

.custom-switch .custom-control-label::before {
    border-radius: 0.5rem;
}

.custom-switch .custom-control-label::after {
    border-radius: 50%;
}
</style>